<bit-no-items [icon]="noCredentialsIcon">
  <ng-container slot="title">{{ "nothingToShow" | i18n }}</ng-container>
  <ng-container slot="description">{{ "nothingGeneratedRecently" | i18n }}</ng-container>
</bit-no-items>
